import { KernelInterface } from "@/Kernel/Kernel";

/*
 * Set up Git Version
 */
//window.version = `${GIT_VERSION}::${GIT_BRANCH}::${GIT_COMMITHASH}`;

/*
 * Warmup the Kernel and then start the application.
 */
KernelInterface.warmUp().then(() => {
  import(/* webpackChunkName: "AppMain" */ "./AppMain");
});
